import { render, staticRenderFns } from "./register-success.vue?vue&type=template&id=baef8ac2&"
import script from "./register-success.vue?vue&type=script&lang=js&"
export * from "./register-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports